import { useState, useCallback } from 'react';
import { graphQlClient } from '@config/graphqlClient';
import EventGraphQL from '@graphql/event.queries';
import { Event } from '@models/event.model';

interface UseEventReturn {
  loading: boolean;
  event: Event | null;
  error: string | null;
  setEvent: (event: Event | null) => void;
  fetchEvent: (eventId: string) => Promise<void>;
}

export const useEvent = (): UseEventReturn => {
  const [event, setEvent] = useState<Event | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchEvent = useCallback(async (eventId: string) => {
    if (!eventId) return;

    setLoading(true);
    setError(null);

    try {
      const data: any = await graphQlClient.request(
        EventGraphQL.queries.getEvent,
        { eventId },
      );

      const fetchedEvent = data?.getEvent || null;
      setEvent(fetchedEvent);
    } catch (err: any) {
      setError(err?.response?.errors?.[0]?.message || 'Failed to fetch event');
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    event,
    loading,
    error,
    fetchEvent,
    setEvent,
  };
};
